import { useQuery } from '@tanstack/react-query';
import { createHistoryReader, createRpcClient } from '@gonka-wallet/chain';
import { useSettingsStore } from '../stores/settingsStore.js';
import { resolveSeeds } from '../lib/resolveSeeds.js';

export function useHistory(address: string | null) {
  const source = useSettingsStore((s) => s.chainNodeSource);
  const customUrl = useSettingsStore((s) => s.customNodeUrl);
  const presetNodeId = useSettingsStore((s) => s.presetNodeId);

  return useQuery({
    queryKey: ['history', address, source, customUrl, presetNodeId],
    queryFn: async () => {
      if (!address) return null;
      const seeds = resolveSeeds(source, customUrl, presetNodeId);
      const client = createRpcClient(seeds);
      const reader = createHistoryReader(client, null);
      return reader.get(address);
    },
    enabled: !!address,
    staleTime: 30_000,
  });
}
